import React from 'react';
import { NavLink } from 'react-router-dom';
const Us1_lev = () => {
  return (
    <div className='fixed top-24 right-0 left-0  justify-items-stretch w-full  content-center items-center z-200'>      
      <div className="h-24 grid grid-cols-6 flex bg-[#007bff]"> 
      
      <NavLink to="/tutoring/learner/us1/us1_pre" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Pre-School: Pre-K</NavLink>     
      
      <NavLink to="/tutoring/learner/us1/us1_ele" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Elementary School: K1-K5</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_mid" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Middle School: K6-K8</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_hig" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >High School: K9-K12</NavLink> 
        <NavLink to="/tutoring/learner/us1/us1_st" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Standardized Tests</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_ter" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Colleges and University</NavLink>
      </div>  
    </div>
  );
}

export default Us1_lev;
